import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "opsgenie",
  "use": "opsgenie-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"opsgenie\"><path d=\"M7.97 7.825a3.12 3.12 0 1 0 0-6.242 3.12 3.12 0 0 0 0 6.242\" /><path d=\"M10.858 12.258a14.4 14.4 0 0 0 2.48-3.266.174.174 0 0 0-.021-.22.2.2 0 0 0-.067-.043l-2.567-1.341c-.116-.059-.233-.03-.262.058a10.4 10.4 0 0 1-2.45 2.887A10.9 10.9 0 0 1 5.55 7.446a.204.204 0 0 0-.262-.058L2.72 8.729a.175.175 0 0 0-.088.263 15.2 15.2 0 0 0 2.45 3.266h.059a13 13 0 0 0 2.829 2.159 12.5 12.5 0 0 0 2.858-2.13h.03z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol